import { SVGAttributes } from "react";

export const CalloutIcon = (
  props: SVGAttributes<SVGElement> & { size: "small" }
) => {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        clipPath="url(#clip0_5261_612)"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="currentColor"
      >
        <path d="M0 4.571c0-.749 0-1.778 1.085-1.778l6-.286 6-2.286A2 2 0 0116 2v9a2 2 0 01-2.915 1.779l-6-2.286-6-.286C0 10.207 0 9.177 0 8.43V4.57zM2 8.43V4.57l6-.285L14 2v9L8 8.714 2 8.43z" />
        <path d="M3 10c-1 0-1 0-1 1l2 4s.448 1 1 1h4c1.582 0 1-.916 1-1l-2-4s-.448-1-1-1H3zm3.75 2H4.5l1 2h2.36l-1.11-2z" />
      </g>
      <defs>
        <clipPath id="clip0_5261_612">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
CalloutIcon.displayName = "CalloutIcon";
